import {
  Button,
  NavBar,
  Icon,
  Toast,
  Tabs,
  WhiteSpace,
  SearchBar,
  List,
  InputItem,
  Modal,
} from "antd-mobile";
import moment from "moment";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../../util/axios";
const JixiaoList = styled.div`
  .body {
    height: 100%;
  }
  .month p {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d7d7d7;
  }
`;
export default function MonthDetails() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
  }>({
    visible: false,
  });
  const history = useHistory();
  const [standardList, setStandardList] = useState<any[]>([]);
  const [informationList, setInformationList] = useState<{
    name?: string;
    department?: string;
    uuid: string;
  }>({
    name: "",
    department: "",
    uuid: "",
  });
  const [starttimeList, setStarttimeList] = useState<{
    time: number;
  }>({ time: 1 });
  const [endtimeList, setEndtimeList] = useState<{
    time: number;
    status: string;
  }>({ time: 1, status: "" });
  const [text, setText] = useState<string>("");
  // 评分标准
  useEffect(() => {
    instance
      .get(
        `/oa/examSetting/standardSetting/getScoreRangeStandardList?timeType=` +
          "month"
      )
      .then((resp) => {
        // console.log(resp)
        // console.log(resp.data.Data.data)
        if (resp.data.Status === "1") {
          setStandardList(resp.data.Data);
          // console.log(staffList)
        }
      });
  }, []);
  useEffect(() => {
    // 获取开始时间
    const nowTime1 = new Date();
    // console.log(nowTime1)
    // console.log(nowTime1.getTime())
    const nowTime = nowTime1.getTime();
    setStarttimeList({
      ...starttimeList,
      time: nowTime,
    });
    let url = decodeURI(window.location.href); //获取请求进来的完整url
    // console.log(url)
    let tstr = url.substring(url.indexOf("?") + 1).split("&"); //先截取url的?后面的参数部分，在根据&分割成参数数组
    // console.log(tstr[1].substring(0, (tstr[1]).indexOf('c')))
    // console.log(tstr[2].substring(0, (tstr[2]).indexOf('c')))
    // console.log(tstr)
    let tstr0 = tstr[0].substring(9);
    let tstr1 = tstr[1].substring(0, tstr[1].indexOf("c"));
    let tstr2 = tstr[2].substring(0, tstr[2].indexOf("c"));
    // let tstr3=parseInt(tstr[3]
    let tstr3 = tstr[3];
    let tstr4 = tstr[4];
    // console.log(tstr0)
    setText(tstr[3]);
    setInformationList({
      name: tstr1,
      department: tstr2,
      uuid: tstr4,
    });
    instance
      .get(
        `/oa/examMonth/getMonthNoticeExecuteList?permissionType=` + "staffMe"
      )
      .then((resp) => {
        // console.log(resp)
        // console.log(resp.data.Data.data)
        // 获取结束时间
        if (resp.data.Status === "1") {
          let data1 = resp.data.Data.data.find(
            (item: any) => item.vSheetId === tstr0
          );
          // console.log(data1)
          const khTime = new Date(data1.考核结束时间).getTime();
          const Status = data1.status;
          setEndtimeList({
            ...endtimeList,
            time: khTime,
            status: Status,
          });
        }
        // console.log(endtimeList.time)
      });
  }, []);
  return (
    <>
      <JixiaoList>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  // history.push(
                  //     `/hr/jxassessment/monthassessment`
                  // );
                  history.go(-1);
                }}
              />
            }
          >
            考核详情
          </NavBar>
          <WhiteSpace />
          <div style={{ padding: "10px 20px 10px 20px" }} className="month">
            {
              <>
                <p>
                  <span>被考核人</span>
                  <span>{informationList.name}</span>
                </p>
                <p>
                  <span>部门</span>
                  <span>{informationList.department}</span>
                </p>
                <p>
                  <span>工作报告</span>
                  <span>工作报告名</span>
                  {/* <span>{endtimeList.time}</span> */}
                </p>
              </>
            }
          </div>
          {starttimeList.time > endtimeList.time ||
          endtimeList.status == "未全部打分已提报" ||
          endtimeList.status == "已全部打分已提报" ? (
            <List>
              <InputItem
                type="number"
                placeholder="必填"
                value={text}
                maxLength={3}
                editable={false}
                style={{ padding: "0px 20px 0px 20px" }}
              >
                <span style={{ color: "red" }}>*</span>评价打分
              </InputItem>
            </List>
          ) : (
            <List>
              <InputItem
                type="number"
                placeholder="必填"
                // onVirtualKeyboardConfirm={v => console.log('虚拟键盘点击确认时的回调函数:', v)}
                value={text}
                maxLength={3}
                editable={true}
                clear
                onChange={(value) => {
                  // const count = parseInt(value);
                  console.log(value);
                  setText(value);
                }}
                style={{ padding: "0px 20px 0px 20px" }}
              >
                <span style={{ color: "red" }}>*</span>评价打分
              </InputItem>
            </List>
          )}

          <p style={{ padding: "0px 20px 0px 20px" }}>
            <span
              style={{ color: "#108ee9" }}
              onClick={() =>
                setTankuang({
                  visible: true,
                })
              }
            >
              查看评价标准
            </span>
          </p>

          <div style={{ padding: "0px 20px 0px 20px", marginTop: 130 }}>
            {starttimeList.time > endtimeList.time ||
            endtimeList.status == "未全部打分已提报" ||
            endtimeList.status == "已全部打分已提报" ? (
              <Button
                type="primary"
                onClick={() => {
                  Toast.info("考核已上报或者考核时间已过", 2);
                }}
              >
                提交
              </Button>
            ) : (
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    if (text == "必填" || text == "") {
                      Toast.info("请填写必填项");
                    } else {
                      instance
                        .post(
                          `/oa/examMonth/saveMonthExamMarkScore?examMonthStaffId=` +
                            informationList.uuid +
                            "&score=" +
                            text
                        )
                        .then((resp) => {
                          if (resp.data.Status === "1") {
                            Toast.info(resp.data.Data);
                            setTimeout(function () {
                              history.go(-1);
                            }, 2000);
                          }
                        });
                    }
                  }}
                >
                  提交
                </Button>
                <WhiteSpace />
              </>
            )}
          </div>
          {/* 评分弹框 */}
          <Modal
            visible={tankuang.visible}
            transparent
            maskClosable={false}
            onClose={() =>
              setTankuang({
                visible: false,
              })
            }
            title="评价标准"
            footer={[
              {
                text: "关闭",
                onPress: () => {
                  setTankuang({
                    visible: false,
                  });
                },
              },
            ]}
          >
            <div style={{ height: 200, overflow: "scroll" }}>
              {standardList.map((item) => (
                <>
                  <p>
                    {item.name}[{item.minScore},{item.maxScore})
                  </p>
                </>
              ))}
            </div>
          </Modal>
        </div>
      </JixiaoList>
    </>
  );
}
